import { LECTURE_VIDEO_TYPES } from "./lecture.const";

/**
 * @typedef Lecture
 *
 * @property {string}               _id             인덱스
 *
 * @property {string}               _category       카테고리 인덱스
 * @property {string}               _company        등록회원 인덱스
 * @property {string}               _thumb          썸네일 인덱스
 * @property {array}                _files          교육자료 인덱스
 *
 * @property {string}               subject         제목
 *
 * @property {object}               video           영상
 * @property {LectureVideoTypes}    video.type      영상유형
 * @property {string}               video.link      영상주소
 *
 * @property {array}                files           교육자료 (파일)
 * @property {Lecture_LinksItem[]}  links           교육자료 (링크)
 *
 * @property {object}               code            참여코드
 * @property {boolean}              code.isOn       참여코드사용
 * @property {string}               code.link       참여코드문자
 *
 * @property {boolean}              isActive        접근활성 여부
 * @property {boolean}              isPublic        목록공개 여부
 * @property {boolean}              isStream        실시간 여부
 * @property {boolean}              isMiceNow       MICE Now 여부
 */

/** @typedef {keyof (typeof LECTURE_VIDEO_TYPES)} LectureVideoTypes */

/**
 * @param {Lecture} lecture
 * @returns {Lecture}
 */
export function initLecture(lecture = {}) {
    return {
        ...(lecture || {}),

        _id: lecture?._id || null,

        _category: lecture?._category || null,
        _company: lecture?._company || null,
        _thumb: lecture?._thumb || null,
        _files: [...(lecture?._files || [])],

        subject: lecture?.subject || null,

        video: {
            ...(lecture?.video || {}),
            type: lecture?.video?.type || LECTURE_VIDEO_TYPES.UTUBE.value,
            link: lecture?.video?.link || null,
        },

        files: [...(lecture?.files || [])],
        links: [...(lecture?.links || [])].map(initLecture__LinksItem),

        code: {
            ...(lecture?.code || {}),
            isOn: lecture?.code?.isOn || false,
            text: lecture?.code?.text || null,
        },

        isActive: lecture?.isActive || false,
        isPublic: lecture?.isPublic || false,
        isStream: lecture?.isStream || false,
        isMiceNow: lecture?.isMiceNow || false,
    };
}

/**
 * @typedef Lecture_LinksItem
 *
 * @property {string}               name            명칭
 * @property {string}               href            주소
 * @property {boolean}              isDownload      다운로드링크
 *
 * @property {string}               tempId          임시 인덱스
 */

/**
 * @param {Lecture_LinksItem} lecture
 * @returns {Lecture_LinksItem}
 */
export function initLecture__LinksItem(item = {}) {
    return {
        ...(item || {}),

        name: item?.name ?? null,
        href: item?.href ?? null,
        isDownload: item?.isDownload ?? false,

        tempId: item?.tempId ?? Math.random(),
    };
}

/**
 * @typedef LectureState
 *
 * @property {string|undefined}     _lecture        영상 인덱스
 * @property {Lecture|undefined}    lecture         영상 데이터
 * @property {boolean|undefined}    isAccessible    접근가능 여부
 */

/**
 * @param {LectureState} lecture
 * @returns {LectureState}
 */
export function initLectureState(state = {}) {
    return {
        ...(state || {}),

        _lecture: state?._lecture || undefined,
        lecture: state?.lecture || undefined,

        isAccessible: state?.isAccessible || undefined,
    };
}
